import { useMemo } from "react";

import {
	HTML_ONPAGE,
	HTML_STANDARD
} from "utils/constants";

// Only show the adjust framing button if following conditions are true
// 1. The creative type is one of the following: HTML Onpage, HTML Standard
// 2. (AND) The creative version has at least one image variable
// 3. (AND) that image variable has framing properties
export default function useFramingCheck(creativeDetails, variableConfig, extraAdTypes = []){
	const showAdjustFramingButton = useMemo(() => {
		if ([HTML_ONPAGE, HTML_STANDARD, ...extraAdTypes].includes(creativeDetails?.adType)){
			let variable = null;

			for (variable in variableConfig) {
				const variableInfo = variableConfig[variable]
					, { type, cropMetadata } = variableInfo
					, { frame } = cropMetadata || {}
					;

				if (type === "Image" && frame?.width && frame?.height) {
					return true;
				}	//end if(type)
			}	//end for(var in varConfig)
		}	//end if(adTypeList.includes(adType))

		return false;
	}, [creativeDetails, variableConfig, extraAdTypes]);

	return showAdjustFramingButton;
}
